import { Button, Input, Modal, Select, Radio, Bubble, Icon } from '@tencent/tea-component';
import { useEffect, useState } from 'react';

const CI_DEFAULT = 'ci-500-gdpr';
const SDKAPPID_DEFAULT = '1400143280';
const DISTRICT_DEFAULT = '1';
const XMPP_DEFAULT = 'wss://ws-voov-500.cicd.tencentmeeting.com/websocket/connection';

const customSdkAppId = window.localStorage.getItem('customSdkAppId');
const customCi = window.localStorage.getItem('customCi');
const customDistrict = window.localStorage.getItem('customDistrict');

const EnvSelect = () => {
  const [value, setValue] = useState(customCi || CI_DEFAULT);
  const [sdkappId, setSdkAppId] = useState(customSdkAppId || SDKAPPID_DEFAULT);
  const [district, setDistrict] = useState(customDistrict || DISTRICT_DEFAULT); // 默认海外
  const [options, setOptions] = useState<any[]>([]);
  useEffect(() => {
    const arr = [
      {
        text: 'ci-500-gdpr',
        value: 'ci-500-gdpr',
      },
    ];
    for (let index = 0; index < 1000; index++) {
      arr.push({
        text: `ci-${index}`,
        value: `ci-${index}`,
      });
      arr.push({
        text: `ci-${index}-gdpr`,
        value: `ci-${index}-gdpr`,
      });
    }
    setOptions(arr);
  }, []);

  const onSelectChange = (v: any) => {
    console.log('v:', v);
    setValue(v);
  };

  const onSave = () => {
    const envArr = value.split('-');
    let xmppUrl = '';
    console.log('envArr:', envArr);
    // wss://ws-voov-500.cicd.tencentmeeting.com/websocket/connection
    if (envArr.length === 3) {
      // gdpr 环境
      xmppUrl = `wss://ws-voov-${envArr[1]}.cicd.tencentmeeting.com/websocket/connection`;
    } else {
      // 不带gdpr的没有-voov
      xmppUrl = `wss://ws${envArr[1]}.cicd.tencentmeeting.com/websocket/connection`;
    }

    localStorage.setItem('customCi', value);
    localStorage.setItem('customXmppUrl', xmppUrl);
    localStorage.setItem('customSdkAppId', sdkappId);
    localStorage.setItem('customDistrict', district);

    Modal.success({
      message: '设置成功',
      description: (
        <div>
          刷新页面重新入会,将使用如下配置
          <br />
          当前选择环境: {value}
          <br />
          xmpp链接: {xmppUrl}
          <br />
          sdkAppId: {sdkappId}
          <br />
          链接国内/国外: {district}
        </div>
      ),
      onClose: () => {
        window.location.reload();
      },
    });
  };

  const reset = () => {
    setSdkAppId(SDKAPPID_DEFAULT);
    setValue(CI_DEFAULT);
    setDistrict(DISTRICT_DEFAULT);

    localStorage.setItem('customCi', CI_DEFAULT);
    localStorage.setItem('customXmppUrl', XMPP_DEFAULT);
    localStorage.setItem('customSdkAppId', SDKAPPID_DEFAULT);
    localStorage.setItem('customDistrict', DISTRICT_DEFAULT);

    Modal.success({
      message: '成功恢复默认设置',
      description: (
        <div>
          刷新页面重新入会,将使用如下配置
          <br />
          当前选择环境: {CI_DEFAULT}
          <br />
          xmpp链接: {XMPP_DEFAULT}
          <br />
          sdkAppId: {SDKAPPID_DEFAULT}
          <br />
          链接国内/国外: {DISTRICT_DEFAULT}
        </div>
      ),
      onClose: () => {
        window.location.reload();
      },
    });
  };

  return (
    <div>
      <Button type="link" onClick={reset}>
        恢复到默认值
      </Button>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <a style={{ color: '#006eff' }} href="https://iwiki.woa.com/p/4009481955" target="_blank" rel="noreferrer">
        使用文档
      </a>
      <br />
      <span style={{ width: '60px', display: 'inline-block' }}>ci环境:</span>
      <Select
        searchable
        matchButtonWidth
        size="m"
        appearance="button"
        value={value}
        options={options}
        onChange={onSelectChange}
      />
      <br />
      <span style={{ width: '60px', display: 'inline-block' }}>sdkAppId:</span>
      <Input value={sdkappId} onChange={(v) => setSdkAppId(v)} />
      &nbsp;
      <Bubble arrowPointAtCenter placement="top-end" content="sdkAppId，当你不知道你的环境应该是什么的时候就别改">
        <Icon type="info" />
      </Bubble>
      <div style={{ marginTop: '10px' }}>
        <Radio.Group value={district} onChange={(value) => setDistrict(value)}>
          <Radio name="0">连接国内</Radio>
          <Radio name="1">连接国外</Radio>
        </Radio.Group>
        &nbsp;
        <Bubble
          arrowPointAtCenter
          placement="top-end"
          content="默认国外，如果出现链接不上，可以试试切换国内，可能ci环境海外没有部署"
        >
          <Icon type="info" />
        </Bubble>
      </div>
      <Button type="primary" style={{ marginTop: '10px' }} onClick={onSave}>
        保存设置
      </Button>
    </div>
  );
};

export default EnvSelect;
